/*
 * @Author: 张天昊
 * @Date: 2024-05-23 12:18:36
 * @LastEditTime: 2024-05-25 16:05:06
 * @LastEditors: 张天昊
 * @Description:
 * @FilePath: /Mobile/src/pages/itineraryUniversal/composables/useCardContainerEl.js
 */
import { ref } from 'vue';
export function useCardContainerEl() {
  const container = ref();
  return {
    container
  };
}
